import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useToastContext } from '../../../contexts/ToastProvider';
import propertyAttachmentsAPI from '../../../services/api/property-attachments';
import {
  StyledButton,
  StyledDocumentDownloadIcon,
  StyledDocumentTitle,
  StyledDocumentWrapper,
  StyledInnerWrapper,
  StyledLabel,
  StyledNav,
} from './PropertyAttachmentCalcoloCanoneConcordatoField.styles';
import {
  IPropertyAttachmentDocument,
  IPropertyAttachmentFieldProps,
} from './PropertyAttachmentCalcoloCanoneConcordatoField.types';

const PropertyAttachmentCalcoloCanoneConcordatoField = ({
  title,
  type,
  property_id,
}: IPropertyAttachmentFieldProps): JSX.Element | null => {
  const { t } = useTranslation(['a11y']);
  const toast = useToastContext();
  const [fileLoading, setFileLoading] = useState(false);
  const [documents, setDocuments] = useState<IPropertyAttachmentDocument[]>([]);

  const fetchDocument = async () => {
    try {
      setFileLoading(true);
      const response = await propertyAttachmentsAPI.getPropertyAttachmentByType(
        {
          propertyId: property_id,
          type: type,
        },
      );
      setDocuments(response ?? []);
    } catch (error) {
      toast.error(t('Unable to fetch document'));
      console.error('Fetch error:', error);
    } finally {
      setFileLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument();
  }, []);

  const handleOnViewButtonClick = async (index: number) => {
    const attachmentLink =
      await propertyAttachmentsAPI.getPropertyAttachmentURL({
        propertyId: property_id,
        propertyAttachmentId: documents[index].id!,
      });
    if (attachmentLink === undefined) return;

    window.open(attachmentLink, '_blank');
  };

  if (fileLoading) return null;

  return (
    <>
      {!isEmpty(documents) && <StyledLabel>{title}</StyledLabel>}
      {documents.map((document, index) => (
        <StyledDocumentWrapper
          key={`property-attachment-${document.id}-${index}`}
        >
          <StyledInnerWrapper>
            <StyledDocumentTitle>{document.filename}</StyledDocumentTitle>
            <br />
            <StyledNav>
              <StyledButton
                onClick={() => handleOnViewButtonClick(index)}
                title={t('a11y:viewDocument')}
                type="button"
              >
                <StyledDocumentDownloadIcon />
              </StyledButton>
            </StyledNav>
          </StyledInnerWrapper>
        </StyledDocumentWrapper>
      ))}
    </>
  );
};

export default PropertyAttachmentCalcoloCanoneConcordatoField;
